import React from 'react';
import Image from 'next/image';
import Head from 'next/head';
import Link from 'next/link';

import { FarmerTestimonials } from '../../Data/farmertestimonials';

import grapes_png from '../../assets/crops/pngs/grapes.png';
import orange_png from '../../assets/crops/pngs/orange.png';
import pomogranate_png from '../../assets/crops/pngs/pomegranate.png';

import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';

const chooseImage = {
  grapes: grapes_png,
  Kinnow: orange_png,
  pomegranate: pomogranate_png,
};
export default function farmerstalk() {
  return (
    <div>
      <Head>
        <meta name="title" content="Fyllo Farmer testimonials: Farmer reviews from different reg" />
        <meta
          name="description"
          content="Farmers have saved lots of water and fertilizer using Fyllo. Their farm produce is increased by 25-30%."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="fyllo farmers, fyllo farmer testimonial, fyllo reviews, farmer reviews, grapes farmer reviews, pomegranate farmer reviews, kinnow farmer reviews, fyllo weather station review, fyllo main unit review, nero unit review, nero product review, kairo unit review, kairo main unit review, "
        />
        <meta name="robots" content="index,follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="30 days" />
        <meta name="author" content="Fyllo" />

        <title>Fyllo Farmer testimonials: Farmer reviews from different regions in different crops</title>
        <meta
          name="title"
          content="Fyllo Farmer testimonials: Farmer reviews from different regions in different crops"
        />
        <meta
          name="description"
          content="Farmers have saved lots of water and fertilizer using Fyllo. Their farm produce is increased by 25-30%."
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fyllo.in/" />
        <meta
          property="og:title"
          content="Fyllo Farmer testimonials: Farmer reviews from different regions in different crops"
        />
        <meta
          property="og:description"
          content="Farmers have saved lots of water and fertilizer using Fyllo. Their farm produce is increased by 25-30%."
        />
        <meta
          property="og:image"
          content="https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@site_account" />
        <meta name="twitter:creator" content="@fylloTech" />
        <meta name="twitter:url" content="https://twitter.com/fyllotech?lang=en" />
        <link rel="manifest" href="/site.webmanifest" />
        <meta
          property="twitter:title"
          content="Fyllo Farmer testimonials: Farmer reviews from different regions in different crops"
        />
        <meta
          property="twitter:description"
          content="Farmers have saved lots of water and fertilizer using Fyllo. Their farm produce is increased by 25-30%."
        />
        <meta
          property="twitter:image"
          content="https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"
        />
      </Head>
      <section className="bg-white text-left">
        <div className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
          <div className="mx-auto max-w-screen-sm">
            <MainHeading text="Testimonials" />
            <SubHeading text="Listen to what Fyllo farmers say about our technology" />
          </div>
          <div className="grid mb-8 gap-5 lg:mb-12 ">
            {FarmerTestimonials.map((farmer, i) => {
              return (
                <figure
                  key={i}
                  className="relative flex flex-col justify-center items-center  text-left bg-gray-50 border-b border-gray-200 p-4 md:p-8  lg:border-r "
                >
                  {/* <Image className="z-10 absolute h-full w-full object-cover " src={chooseImage[farmer.crop]} alt={farmer.crop??'crop'}/> */}
                  <div className="z-20  h-full w-full  backdrop-blur-xl p-1 ">
                    <figcaption className=" flex flex-col md:flex-row gap-5 w-full items-center">
                      <Image
                        className="w-28 h-28 aspect-square rounded-full object-cover"
                        src={farmer.image}
                        alt="profile picture"
                        sizes="(max-width: 768px) 100vw,
                              (max-width: 1200px) 50vw,
                              33vw"
                      />
                      <div className="space-y-0.5 h-full flex flex-col justify-center items-start font-medium  text-left">
                        <div className="text-xl text-slate-800 mt-2">{farmer.farmerName}</div>
                        <div className="text-sm font-light text-slate-800 ">{farmer.location}</div>
                        <blockquote className="text-slate-800 pt-4 text-xs md:text-base">{farmer.text}</blockquote>
                      </div>
                    </figcaption>
                  </div>
                </figure>
              );
            })}
          </div>
          <div className="text-center">
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://youtube.com/playlist?list=PLR-Ry5geufDo-d1NWvNZ-pQPa74HHXbCn"
              className="py-2.5 px-5 mr-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-fyllo-800 focus:z-10 focus:ring-4 focus:ring-gray-200     "
            >
              Show more...
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
